import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import { HttpClient } from "@angular/common/http";
import { FormIODefinition } from "@features/bb-formio";
import { MultiUserFormDef, NewMultiUserFormDefinition } from "../dto/multi-user-form.dto";
import { MUFUserTargets } from "../dto/multi-user-form-stage.dto";
import { EntityId } from "@bbwt/interfaces";

@Injectable()
export class MultiUserFormService extends PagedCrudService<MultiUserFormDef> {
    public readonly url = "api/multi-user-form";
    public readonly entityTitle = "Multi User Form";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public async getFormDefinitions() {
        return await this.handleRequest<FormIODefinition[]>(
            this.http.get<FormIODefinition[]>(`${this.url}/form-definitions`),
            this.handlersFactory.getDefault()
        );
    }

    public async getUserTargets() {
        return await this.handleRequest<MUFUserTargets[]>(
            this.http.get<MUFUserTargets[]>(`${this.url}/user-targets`),
            this.handlersFactory.getDefault()
        );
    }

    public async getInstanceTargets(id: string) {
        return await this.handleRequest<MUFUserTargets[]>(
            this.http.get<MUFUserTargets[]>(`${this.url}/instance-targets/${id}`),
            this.handlersFactory.getDefault()
        );
    }

    public async addNewMUF(dto: NewMultiUserFormDefinition): Promise<MultiUserFormDef> {
        return await this.handleRequest<MultiUserFormDef>(
            this.http.post<MultiUserFormDef>(`${this.url}/new-muf`, dto),
            this.handlersFactory.getForCreate("New Multi-User Form")
        );
    }

    public async isMUFReady(id: string) {
        return await this.handleRequest<boolean>(this.http.get<boolean>(`${this.url}/muf-ready/${id}`), this.handlersFactory.getDefault());
    }

    async getByFormRevisionId(formRevisionId: EntityId): Promise<MultiUserFormDef> {
        return await this.handleRequest<MultiUserFormDef>(
                this.http.get<MultiUserFormDef>(`${this.url}/form-revision/${formRevisionId}`),
            this.handlersFactory.getDefault()
        );
    }
}
